<template>
  <v-container class="px-1">
      <v-form ref="filterConsultaPgtoForm">
      <v-row>
          <v-col class="py-0 px-2" cols="2">
            <label>Data entre</label>
            <v-menu
                ref="dtI"
                v-model="dtI"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateIFormatted"
                    dense
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="dateI = parseDate(dateIFormatted)"
                    :rules="[formRules.typeDateFormated]"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="dateI" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0 px-2" cols="2">
            <label>até</label>
            <v-menu
                ref="dtF"
                v-model="dtF"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateFFormatted"
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="dateF = parseDate(dateFFormatted)"
                    :rules="[formRules.typeDateFormated]"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="dateF" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          </v-row>
      <v-row>
           <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Prestador</label>
            <v-autocomplete
              v-model="formData.prestador_id"
              :items="prestadoresFilter"
              item-value="id"
              item-text="prest_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="prestadoresFilter.length==1"
              :search-input.sync="searchInput" 
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'prestador_id')" :class="formData.prestador_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.prest_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.prestador_id.length>1? 'max-width:30%':'max-width:100%'">{{
              data.item.prest_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.prestador_id.length == 3
                  ? formData.prestador_id.length - 2 + " outro"
                  : formData.prestador_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
          <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Operadoras</label>
            <v-autocomplete
              v-model="formData.operadora_ans_id"
              :items="operadorasFilter"
              item-value="id"
              item-text="oper_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="operadorasFilter.length==1"
              :search-input.sync="searchInput" 
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'operadora_ans_id')" :class="formData.operadora_ans_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.oper_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.operadora_ans_id.length>1? 'max-width:30%':'max-width:100%'">{{
              data.item.oper_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.operadora_ans_id.length == 3
                  ? formData.operadora_ans_id.length - 2 + " outro"
                  : formData.operadora_ans_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col class="py-0 px-2" cols="2">
            <label>Data da quitação</label>
            <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dataQuitacaoFormated"
                    dense
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="formData.data_quitacao = parseDate(dataQuitacaoFormated)"
                    :rules="[formRules.typeDateFormated]"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="formData.data_quitacao" @input="dataQuitacaoFormated=formatDate(formData.data_quitacao)" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
      <v-col class="pt-5 px-2">
          <v-spacer/>
          <v-btn
            small 
            height="32px"
            color="primary"
            class="px-1 mr-3"
            depressed
            @click="sendFilter()"
            >Filtrar</v-btn>
          <v-btn
            outlined
            small 
            height="32px"
            color="primary"
            class="px-1 ml-1"
            depressed
            @click="clearFilters()"
            >Limpar Filtro</v-btn>
      </v-col>
      </v-row>
      </v-form>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
export default {
    data() {
        return{
            formData: {
                prestador_id: [],
                operadora_ans_id: [],
                data_inicio: null,
                data_fim: null,
                data_quitacao: null
            },
            dtI: false,
            dateI:null,
            dateIFormatted: null,
            dtF: false,
            dateF: null,
            dateFFormatted: null,
            dataQuitacaoFormated: null,
            prestadoresFilter: [],
            operadorasFilter: [],
            statusFilter: [],
            currentValue: false,
            qtdDays: 30,
            searchInput: null
        }
    },
    computed: {
        ...mapState({
            formRules: state => state.formRules
        }),
  },  
    watch: {
        prestadores:{
            deep: true,
            handler(val){
                this.prestadoresFilter = Array.from(val)
                if (val && val.length==1) {
                    this.formData.prestador_id = [val[0].id]
                } 
                // else {
                    // this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
                // }
            }
        },
        operadoras:{
            deep: true,
            handler(val){
                this.operadorasFilter = Array.from(val)
                if (val && val.length==1) {
                    this.formData.operadora_ans_id = [val[0].id]
                } 
            }
        },
        statusList:{
            deep: true,
            handler(val){
                this.statusFilter = Array.from(val)
                this.statusFilter.unshift({id: null, descricao: "Selecione", cor: null})
            }
        },
        dateF(val){
            if (!val) {
                this.dateFFormatted = null
            } else {
                if (!!this.dateI && Date.parse(this.dateI) > Date.parse(val)){
                  this.dateI = val
                }
                this.dateFFormatted = this.formatDate(val)
            }
        },
        dateFFormatted(val){
            this.formData.data_fim = this.parseDate(val)
        },
        dateI(val){
            // this.qtdDays = moment(val).endOf('month').format('DD-MM-YYYY').split('-')[0]-1
            if (!val) {
                this.dateIFormatted = null
            } else {
               if (!!this.dateF && Date.parse(this.dateF) < Date.parse(val)){
                  this.dateF = val
                }
              this.dateIFormatted = this.formatDate(val)
            }
        },
        dateIFormatted(val){
            this.formData.data_inicio = this.parseDate(val)
        },
        mesCorrente: {
            deep: true,
            handler(val){
                if (val.data_inicio != '0001-01-01' || val.data_fim != '0001-01-01') {
                    this.dateI = val.data_inicio
                    this.dateF = val.data_fim
                    setTimeout(() => {this.currentValue = true},100)
                }
            }
        }
    },
    methods: {
        clearFilters(){
            this.formData.operadora_ans_id = []
            this.formData.etapa = null
            this.formData.evento = null
            this.dateI = null
            this.dateF = null
            this.dataQuitacaoFormated = null
            this.formData.data_inicio = null
            this.formData.data_fim = null
            this.formData.data_quitacao = null
            this.currentValue = false
            this.filterList(this.formData, 1, true)
            if (this.prestadoresFilter.length>1) 
            this.formData.prestador_id = []
            if (this.operadorasFilter.length>1) 
            this.formData.operadora_ans_id = []
        },
        sendFilter(){
          if(this.$refs.filterConsultaPgtoForm.validate()){
            if(!this.formData.data_fim && this.formData.data_inicio) {
                this.dateF = this.formData.data_inicio
                this.formData.data_fim = this.formData.data_inicio
            }
            this.filterList(this.formData, 1)
          }
        },
         toggleAutocomplete(item, campo) {
          this.searchInput = null
          let index = this.formData[campo].indexOf(item.id)
          //  index > -1  está excluindo a operadora
          if (index > -1) {
            this.formData[campo].splice(index, 1)
          } else {
            //  index < 0  está adicionando a operadora
              this.formData[campo].push(item.id)
          }
            this.$nextTick()
            return
        },
    },
    mounted(){
        this.filterList(this.formData, 1)
    },
    props: {
        prestadores: Array,
        operadoras: Array,
        mesCorrente: Object,
        filterList: Function,
        formatDate: Function,
        parseDate: Function,
        statusList: Array,
    }
}
</script>

<style>
.v-text-field--filled.v-input--dense.v-text-field--single-line .v-label, .v-text-field--full-width.v-input--dense.v-text-field--single-line .v-label {
    top: 7px;
}
</style>